import { unref as _unref, normalizeClass as _normalizeClass, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import { Korean } from 'flatpickr/dist/l10n/ko.js';
import appgInput from '@/components/custom/AppgInput.vue';
import { ref, toRefs, computed } from 'vue';
import dayjs from 'dayjs';
export default {
  __name: 'AppgDatePickr',
  props: {
    _class: {
      type: String,
      default: ''
    },
    dateRange: {
      type: String
    },
    label: {
      type: String
    },
    invalidMessage: {
      type: String,
      default: ''
    },
    valid: {
      type: Boolean,
      description: 'Whether is valid',
      default: true
    },
    isRange: {
      type: Boolean,
      default: true
    },
    modelValue: {
      type: String,
      default: ''
    },
    isAfter: {
      type: Boolean,
      default: false
    },
    minDate: {
      type: String
    },
    isBefore: {
      type: Boolean,
      default: false
    },
    maxDate: {
      type: String
    },
    isCalendar: {
      type: Boolean,
      default: true
    },
    isTime: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    isFormGroup: {
      type: Boolean,
      default: true
    },
    required: {
      type: Boolean,
      default: false
    },
    validSet: {
      type: [Object, Boolean],
      default: null
    }
  },
  emits: ['update:modelValue'],
  setup(__props, {
    emit: __emit
  }) {
    const localeKorean = Korean;
    localeKorean.rangeSeparator = ' ~ ';
    const props = __props;
    const emits = __emit;
    const {
      _class,
      label,
      valid,
      isRange,
      modelValue,
      isAfter,
      minDate,
      isCalendar,
      isTime,
      disabled,
      isFormGroup,
      required,
      validSet
    } = toRefs(props);
    const config = computed(() => {
      const config = {
        allowInput: true,
        locale: localeKorean,
        mode: 'range'
      };
      if (!isRange.value) config.mode = 'single';
      if (isAfter.value && minDate.value) config.minDate = dayjs(minDate).format('YYYY-MM-DD');
      config.enableTime = isTime.value;
      config.noCalendar = !isCalendar.value;
      config.time_24hr = true;
      return config;
    });
    const input = ({
      target
    }) => {
      emits('update:modelValue', target.value);
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createBlock(appgInput, {
        label: _unref(label),
        "prepend-icon": `fas ${_unref(isCalendar) ? 'fa-calendar' : 'fa-clock'}`,
        valid: _unref(valid),
        disabled: _unref(disabled),
        "is-form-group": _unref(isFormGroup),
        _class: _unref(_class),
        required: _unref(required),
        "valid-set": _unref(validSet)
      }, {
        default: _withCtx(() => [_createVNode(_unref(flatPickr), {
          config: config.value,
          class: _normalizeClass(["form-control datepicker", {
            'is-invalid': !_unref(valid)
          }]),
          "model-value": _unref(modelValue),
          onChange: input,
          valid: _unref(valid),
          disabled: _unref(disabled)
        }, null, 8, ["config", "model-value", "valid", "class", "disabled"])]),
        _: 1
      }, 8, ["label", "prepend-icon", "valid", "disabled", "is-form-group", "_class", "required", "valid-set"]);
    };
  }
};